import React from 'react';
import { Shield, Heart, Plane, Scale } from 'lucide-react';
import { motion } from 'framer-motion';

const reasons = [
  {
    icon: Heart,
    title: 'Sante & hospitalisation',
    description: 'Frais medicaux et hospitalisation couverts a 100% des frais reels, sans franchise.',
    color: 'text-rose-500 dark:text-rose-400',
    bg: 'bg-rose-50 dark:bg-rose-900/20',
  },
  {
    icon: Plane,
    title: 'Rapatriement 24h/24',
    description: 'Assistance rapatriement disponible a tout moment, partout dans le monde.',
    color: 'text-sky-500 dark:text-sky-400',
    bg: 'bg-sky-50 dark:bg-sky-900/20',
  },
  {
    icon: Scale,
    title: 'Responsabilite civile',
    description: 'Protection en responsabilite civile vie privee incluse dans votre contrat.',
    color: 'text-amber-500 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
  },
  {
    icon: Shield,
    title: 'Obligation PVT',
    description: "L'assurance sante est generalement obligatoire pour valider votre PVT.",
    color: 'text-emerald-500 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
  },
];

export function GeneralInfoSection() {
  return (
    <section className="py-12 sm:py-20 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10 sm:mb-14"
        >
          <h2 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3">
            Pourquoi prendre une assurance ?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Partir bien assure, c'est indispensable quand on va sejourner a l'etranger. Voici les garanties essentielles couvertes.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white dark:bg-gray-800 rounded-2xl p-5 sm:p-6 border border-gray-100 dark:border-gray-700/50 hover:shadow-lg hover:border-gray-200 dark:hover:border-gray-600 transition-all duration-300 group"
            >
              <div className={`w-11 h-11 sm:w-12 sm:h-12 rounded-xl ${reason.bg} flex items-center justify-center mb-4 transition-transform group-hover:scale-110`}>
                <reason.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${reason.color}`} />
              </div>
              <h3 className="text-sm sm:text-base font-bold text-gray-900 dark:text-white mb-2">
                {reason.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                {reason.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
